module.exports = __webpack_public_path__ + "static/media/dock.0a7f607a.svg";